import React, { useState, useEffect, useRef } from 'react';
import { RefreshCw, X, Rocket } from 'lucide-react';
import './UpdateBanner.css';

export default function UpdateBanner() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [updating, setUpdating] = useState(false);
  const reloadingRef = useRef(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    let reg = null;
    let interval = null;

    const onControllerChange = () => {
      if (reloadingRef.current) return;
      reloadingRef.current = true;
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

    const trackInstalling = (worker) => {
      if (!worker) return;
      worker.addEventListener('statechange', () => {
        if (worker.state === 'installed' && navigator.serviceWorker.controller) {
          setWaitingWorker(worker);
          setDismissed(false);
        }
      });
    };

    navigator.serviceWorker.ready.then(registration => {
      reg = registration;
      if (registration.waiting && navigator.serviceWorker.controller) {
        setWaitingWorker(registration.waiting);
      }
      trackInstalling(registration.installing);
      registration.addEventListener('updatefound', () => trackInstalling(registration.installing));
      registration.update().catch(() => {});
      interval = setInterval(() => registration.update().catch(() => {}), 15 * 60 * 1000);
    });

    const onVisible = () => {
      if (document.visibilityState === 'visible' && reg) reg.update().catch(() => {});
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
      document.removeEventListener('visibilitychange', onVisible);
      if (interval) clearInterval(interval);
    };
  }, []);

  if (!waitingWorker || dismissed) return null;

  const applyUpdate = () => {
    setUpdating(true);
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    setTimeout(() => { if (!reloadingRef.current) window.location.reload(); }, 3000);
  };

  return (
    <div className="update-banner" data-testid="update-banner">
      <div className="update-banner-icon"><Rocket size={20} /></div>
      <div className="update-banner-text">
        <strong>Neue Version verfügbar!</strong>
        <span>Aktualisiere jetzt, um die neuesten Funktionen zu erhalten.</span>
      </div>
      <button className="update-banner-btn" onClick={applyUpdate} disabled={updating} data-testid="update-now-btn">
        <RefreshCw size={14} className={updating ? 'spinning' : ''} /> {updating ? 'Lädt...' : 'Jetzt aktualisieren'}
      </button>
      <button className="update-banner-close" onClick={() => setDismissed(true)} aria-label="Später" data-testid="update-dismiss-btn">
        <X size={16} />
      </button>
    </div>
  );
}
